import { useEffect, useRef, useState, type PropsWithChildren } from "react";

export function ClickOutsideListener({
  onClickOutside,
  children,
  as,
}: PropsWithChildren<{ onClickOutside: () => void; as?: "li" }>) {
  const ref = useRef(null);
  const [active, setActive] = useState(false);

  const Tag = as === "li" ? "li" : "div";

  useEffect(() => {
    function handleClickAway(event: MouseEvent | TouchEvent) {
      const currentRef = ref.current as HTMLElement | null;
      if (!currentRef) return;
      const path = event.composedPath();
      if (
        currentRef?.contains(event.target as Node) ||
        path.includes(currentRef)
      ) {
        setActive(true);
      } else if (active) {
        onClickOutside();
        setActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickAway);
    document.addEventListener("touchstart", handleClickAway);

    return () => {
      document.removeEventListener("mousedown", handleClickAway);
      document.removeEventListener("touchstart", handleClickAway);
    };
  }, [active, onClickOutside]);

  return (
    <Tag style={{ display: "contents" }} ref={ref}>
      {children}
    </Tag>
  );
}
